import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const useGetOnlineAssets = (assetId, assetType) => {
  return useQuery({
    queryKey: ["oar", assetId],
    queryFn: async () => {
      const res = await axios.get(
        `/api/oar/online-assets?darAssetId=${assetId}&darAssetType=${assetType}`,
        { validateStatus: (status) => status < 500 },
      );

      if (res.status !== 200) {
        return [];
      }

      return res.data;
    },
  });
};
